export const getStyledName = (model, gridNameStyle) => {
    let modelname = model.Name || ""
    switch (gridNameStyle) {
        case 'first':
            break
        case 'first-and-initial':
            if (model.Surname) {
                modelname += ` ${model.Surname.charAt(0)}`
            }
            break
        case 'first-and-initial-and-dot':
            if (model.Surname) {
                modelname += ` ${model.Surname.charAt(0)}.`
            }
            break
        case 'first-and-last':
        default:
            if (model.Surname) {
                modelname += ` ${model.Surname}`
            }
            break
    }
    return modelname.toLowerCase();
}